import { AnimatePresence, motion } from 'motion/react'
import { type ReactNode } from 'react'
import { useLocation } from 'react-router'

import { anim, opacity } from '#app/utils/animation.js'

export function PageTransition({ children }: { children: ReactNode }) {
	const route = useLocation()

	if (
		route.pathname.includes('products') ||
		route.pathname.includes('magazine') ||
		route.pathname.includes('search')
	)
		return children

	return (
		<AnimatePresence mode="wait" initial={false}>
			<div key={route.key} className="relative">
				<motion.div {...anim(opacity)}>{children}</motion.div>
			</div>
		</AnimatePresence>
	)
}
